import forge from "node-forge";

export type CardEncryptionKey = {
  identifier: string;
  publicKey: string;
};

export type EncryptedCardPin = {
  keyIdentifier: string;
  eNewPIN: string;
};

function parseRsaPublicKeyFromCuscalXml(base64PublicKey: string) {
  const xml = forge.util.decode64(base64PublicKey);
  const modulusMatch = xml.match(/<Modulus>([^<]+)<\/Modulus>/);
  const exponentMatch = xml.match(/<Exponent>([^<]+)<\/Exponent>/);

  if (!modulusMatch?.[1] || !exponentMatch?.[1]) {
    throw new Error("Invalid Cuscal encryption key format");
  }

  const modulus = new forge.jsbn.BigInteger(forge.util.createBuffer(forge.util.decode64(modulusMatch[1])).toHex(), 16);
  const exponent = new forge.jsbn.BigInteger(forge.util.createBuffer(forge.util.decode64(exponentMatch[1])).toHex(), 16);

  return forge.pki.setRsaPublicKey(modulus, exponent);
}

function encryptWithCuscalKey(plaintext: string, encryptionKey: CardEncryptionKey): string {
  const publicKey = parseRsaPublicKeyFromCuscalXml(encryptionKey.publicKey);
  const encrypted = publicKey.encrypt(plaintext, "RSAES-PKCS1-V1_5");
  return forge.util.encode64(encrypted);
}

export function encryptCardPin(pin: string, encryptionKey: CardEncryptionKey): EncryptedCardPin {
  return {
    keyIdentifier: encryptionKey.identifier,
    eNewPIN: encryptWithCuscalKey(pin, encryptionKey),
  };
}

export type EncryptedCardCvv = {
  keyIdentifier: string;
  eCvv: string;
};

export function encryptCardCvv(cvv: string, encryptionKey: CardEncryptionKey): EncryptedCardCvv {
  return {
    keyIdentifier: encryptionKey.identifier,
    eCvv: encryptWithCuscalKey(cvv, encryptionKey),
  };
}
